import { _, Marionette, Radio } from "../../vendor";

import _$ from "../utils/_$"; // Non-jQuery approach, however un-stable
import Rbac from "../utils/Rbac";
import Inboomai18n from "../utils/Inboomai18n";
import { appErrorTpl } from "./AppAnnouncements";

const InboomaBaseView = Marionette.View.extend({
  t: (a, b, c) => Inboomai18n.translate(a, b, c),

  initialize(props) {
    if (typeof props != "undefined") {
      if (props.parentView) {
        this.parentView = props.parentView;
        this.collection = props.parentView.collection;
      }

      if (props.collection) {
        this.collection = props.collection;
      }

      if (props.model) {
        this.model = props.model;
      }
    }
  },

  onDomRefresh(view) {
    if (this.model) {
      // Show/Hide CRUD-action links based on role
      // If read is true but edit is false then fields
      // (e.g. select, text-input) will be shown as disabled
      const that = this;

      this.rbac = new Rbac(this.model);

      _$(view.el)
        .find("[data-inb-action-link]")
        .each(function (elem) {
          const context = _$(elem).closest("[data-inb-context]").first() || {};

          // @todo Turn context back to origin if required
          if (context.elems.length) {
            const contextAttribute = context.attr("data-inb-context");

            if (typeof that.model.attributes[contextAttribute].models !== "undefined") {
              that.rbac.setRoleModel(that.model.attributes[contextAttribute].models[0]);
            } else {
              that.rbac.setRoleModel(that.model.attributes[contextAttribute][0]);
            }
          }

          // This is way too restrictive and can
          // break when sub-views come in
          // -> turned off
          if (false && !that.rbac.hasPermission("read")) {
            const app = Radio.channel("app");
            app.trigger("show:announcement", appErrorTpl);
            return false;
          }

          if (!that.rbac.hasPermission(elem.getAttribute("data-inb-action-link"))) {
            if (elem.nodeName === "SELECT" && that.rbac.hasPermission("read")) {
              elem.setAttribute("disabled", "disabled");
            } else {
              _$(elem).remove();
            }
          }
        });
    }
  },
});

InboomaBaseView.setRenderer(function (template, data) {
  data.t = this.t;

  if (typeof template === "function") {
    return template(data);
  }

  // Called from e.g. loginView
  return _.template(template)(data);
});

export default InboomaBaseView;
